import React, { Component } from 'react';

import Header from './Header'
import MemberOf from './MemberOf';
import Footer from './Footer';
import $ from 'jquery';

class Main extends Component {
    componentDidMount() {
        $.get('/data/services.json').done(data => {
            for (let i = 0, len = data.length; i < len; i++) {
                this.props.addService(data[i]);
            }
        });
        $.get('/data/content.json').done(data => {
            this.props.setContent(data);
        });
    }

    render() {
        return (
            <div>
                <Header content={this.props.content}></Header>
                <div className="row no-gutter">
                    <main className="main col-xs-12">
                        {React.cloneElement(this.props.children, this.props)}
                        <MemberOf></MemberOf>
                    
                    </main>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js